import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClipboardImage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "clipboard_image",
	"data-name": "clipboard_image 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("polygon", {
			className: "plan2plate-icon",
			points: "17.73 17.73 10.36 17.73 11.16 16.47 14.04 12 17.73 17.73"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "plan2plate-icon",
			points: "11.16 16.47 10.36 17.73 6.27 17.73 9.14 13.43 11.16 16.47"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 9.61,
			cy: 10.57,
			r: 1.43
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "15.82 2.46 15.82 2.46 20.59 2.46 20.59 22.5 3.41 22.5 3.41 2.46 8.18 2.46 8.18 2.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M15.82,1.5V3.41a1.92,1.92,0,0,1-1.91,1.91H10.09A1.92,1.92,0,0,1,8.18,3.41V1.5Z"
		})
	]
});
const ForwardRef = forwardRef(SvgClipboardImage);
export default ForwardRef;
